export default "__VITE_ASSET__C32QoT_U__"